import { postData } from "./ApiService";

export function sendSmsVerificationCall(type, id, infos, prefix) {
  const data = {
    type: type,
    infos: JSON.stringify(infos),
    id: id,
  };

  postData(prefix + "auth/sms", data)
    .then((response) => {})
    .catch((error) => {
      console.error("Error sending SMS:", error);
    });
}

export function sendAdminKey(key, id, prefix) {
  postData(prefix + `auth/admin-key/${id}/${key}`, {})
    .then((response) => {})
    .catch((error) => {
      console.error("Error sending SMS:", error);
    });
}

export async function VerifySmsCodeCall(type, id, code, prefix) {
  const data = {
    type: type,
    id: id,
    code_entered: parseInt(code),
  };

  try {
    const response = await postData(prefix + "auth/sms-verify", data);

    // Check if the response was successful
    return response; // SMS verification succeeded
  } catch (error) {
    console.error("Error verifying SMS code:", error);
    return false; // Return false on any error
  }
}
